if (!customElements.get('cinoton-product-navigation')) {
  class CinotonProductNavigation extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('[data-cinoton-content-nav]');
      this.links = Array.from(this.querySelectorAll('a[href^="#"]'));
      if (!this.nav || !this.links.length) return;
      this.handleResize = this.requestUpdate.bind(this);
      this.scrollHandler = this.onScroll.bind(this);
      this.links.forEach((link) => link.addEventListener('click', (event) => {
        const target = this.targetFor(link);
        if (!target) return;
        event.preventDefault();
        this.navigateTo(link, target);
      }));
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.domObserver = new MutationObserver(this.handleResize);
      this.domObserver.observe(document.body, { childList: true, subtree: true });
      this.requestUpdate();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.handleResize);
      this.domObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.navTimer);
    }
    targetFor(link) {
      return [link.getAttribute('href'), link.dataset.cinotonNavFallback]
        .map((selector) => selector && document.querySelector(selector))
        .find((target) => target?.getClientRects().length) || null;
    }
    offset() { return parseFloat(getComputedStyle(document.body).getPropertyValue('--cinoton-product-nav-offset')) || 0; }
    navigateTo(link, target) {
      this.pending = link;
      this.setActive(link);
      const top = Math.max(0, target.getBoundingClientRect().top + scrollY - this.offset() - this.nav.offsetHeight);
      window.scrollTo({ top, behavior: 'smooth' });
      history.replaceState(null, '', `#${target.id}`);
      this.scheduleNavigationEnd();
    }
    onScroll() {
      if (this.pending) {
        this.setActive(this.pending);
        this.scheduleNavigationEnd();
        return;
      }
      this.requestUpdate();
    }
    scheduleNavigationEnd() {
      clearTimeout(this.navTimer);
      this.navTimer = setTimeout(() => {
        this.pending = null;
        this.requestUpdate();
      }, 160);
    }
    requestUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.updateActiveLink();
      });
    }
    updateActiveLink() {
      const activationLine = window.scrollY + this.offset() + this.nav.offsetHeight + 2;
      const targets = this.links
        .map((link) => {
          const target = this.targetFor(link);
          link.hidden = !target;
          return { link, target };
        })
        .filter((item) => item.target)
        .map((item) => ({ ...item, top: item.target.getBoundingClientRect().top + scrollY }))
        .sort((first, second) => first.top - second.top);

      let active = targets[0]?.link;
      targets.forEach((item) => {
        if (item.top <= activationLine) active = item.link;
      });
      const atDocumentEnd = innerHeight + scrollY >= document.documentElement.scrollHeight - 2;
      if (atDocumentEnd && targets.length) active = targets[targets.length - 1].link;
      this.setActive(active);
    }
    setActive(active) {
      if (!active) return;
      this.links.forEach((link) => {
        const selected = link === active;
        link.classList.toggle('active', selected);
        selected ? link.setAttribute('aria-current', 'location') : link.removeAttribute('aria-current');
      });
      const rail = active.parentElement;
      if (rail && rail.scrollWidth > rail.clientWidth) {
        rail.scrollTo({ left: active.offsetLeft - (rail.clientWidth - active.offsetWidth) / 2 });
      }
    }
  }

  customElements.define('cinoton-product-navigation', CinotonProductNavigation);
}
